export default __webpack_public_path__ + "static/media/avatar_2@3x.93e90d5c.png";